export default build =>
    build.query({
        tagTypes: ['allAgents'],
        keepUnusedDataFor: 30,
        query() {
            //console.log("payload",payload)            
            return {
                url: '/exam/getAllAgents',
                method: 'GET',
               // body: payload,
            };
           
        },
       providesTags: ['allAgents']
    })
